<template>
    <div class="grid grid--padding home">
        <div class="homepage">
            <div v-html="$t('homepage.text-intro')" class="homepage__text"></div>

            <div class="homepage__buttons">
                <router-link :to="{name: 'game-about'}" class="btn btn--primary">
                    {{ $t('button.game') }}
                </router-link>
                <router-link :to="{name: 'quiz-start'}" class="btn btn--primary">
                    <img src="@/assets/images/puzzle.svg" :alt="$t('button.quiz')" />
                    {{ $t('button.quiz') }}
                </router-link>
            </div>

            <div class="homepage__text" v-html="$t('homepage.text-project')"></div>
            <div class="homepage__text" v-html="$t('homepage.text-about')"></div>

            <div class="homepage__container homepage__container--top">
                <div class="homepage__label">{{ $t('homepage.project-coordinator') }}</div>
                <div class="homepage__container">
                    <img src="@/assets/images/logo/GTF-logo.svg" alt="GTF logo" class="homepage__logo" />
                </div>
                <div class="homepage__label">{{ $t('homepage.project-partners') }}</div>
                <div class="homepage__container">
                    <img src="@/assets/images/logo/GFZG-logo.png" alt="GFZG logo" class="homepage__logo" />
                    <img src="@/assets/images/logo/Klastera-logo.svg" alt="Klastera logo" class="homepage__logo" />
                </div>
            </div>

            <div v-if="isMobile()" class="homepage__container">
                <div class="homepage__container">
                    <img src="@/assets/images/logo/EU-logo.svg" alt="EU logo" class="homepage__logo homepage__logo--large" />
                    <img src="@/assets/images/logo/ESI-logo.svg" alt="ESI logo" class="homepage__logo" />
                </div>
                <div class="homepage__container">
                    <img src="@/assets/images/logo/ESF-logo.svg" alt="ESF logo" class="homepage__logo" />
                    <img src="@/assets/images/logo/Nacionalna-zaklada-za-razvoj-civilnog-drustva-logo.svg" alt="Nacionalna zaklada za razvoj civilnog društva logo" class="homepage__logo homepage__logo--medium" />
                </div>
                <img src="@/assets/images/logo/Vlada-RH-Ured-za-udruge-logo.svg" alt="Vlada RH Ured za udruge logo" class="homepage__logo" />
            </div>
            <div v-else class="homepage__container">
                <img src="@/assets/images/logo/EU-logo.svg" alt="EU logo" class="homepage__logo homepage__logo--large" />
                <img src="@/assets/images/logo/ESI-logo.svg" alt="ESI logo" class="homepage__logo" />
                <img src="@/assets/images/logo/ESF-logo.svg" alt="ESF logo" class="homepage__logo" />
                <img src="@/assets/images/logo/Nacionalna-zaklada-za-razvoj-civilnog-drustva-logo.svg" alt="Nacionalna zaklada za razvoj civilnog društva logo" class="homepage__logo homepage__logo--medium" />
                <img src="@/assets/images/logo/Vlada-RH-Ured-za-udruge-logo.svg" alt="Vlada RH Ured za udruge logo" class="homepage__logo" />
            </div>

            <div class="homepage__subtitle" v-html="$t('homepage.subtitle')"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeView',
    inject: ['isMobile']
}
</script>
